import { sendEvent } from "../helpers/util";

import { HEADER_EVENT_NAME } from "./header";

// handles all functionality related to instances of the "My account" CTA

export const accountCta = () => {
  const allAccountCtas = document.querySelectorAll("[js-my-account-cta]");

  if (allAccountCtas == null || !allAccountCtas.length) {
    return;
  }

  allAccountCtas.forEach((accountCta) => {
    const ctaType = accountCta.getAttribute("js-my-account-cta");
    const isLoggedIn = accountCta.getAttribute("js-is-logged-in");

    // element ref for menu shown when a primary CTA is selected while logged in
    const loggedInMenu =
      ctaType == "primary"
        ? (accountCta.parentElement?.querySelector(
            "[js-logged-in-menu]"
          ) as HTMLElement)
        : null;

    // for primary CTAs, indicates whether the associated menu is currently open
    const isLoggedInMenuOpen = () =>
      ctaType == "primary"
        ? !loggedInMenu?.classList.contains("max-h--0")
        : false;

    accountCta.addEventListener("click", () => {
      if (ctaType == "primary") {
        if (isLoggedIn) {
          const childrenItems = loggedInMenu?.querySelectorAll("a, button");
          if (!isLoggedInMenuOpen()) {
            // menu is currently hidden; set height
            loggedInMenu!.style.maxHeight = `${loggedInMenu!.scrollHeight}px`;
            childrenItems?.forEach((item) => {
              item.setAttribute("tabindex", "0");
            });
          } else {
            // menu is currently shown; unset height
            loggedInMenu!.style.removeProperty("max-height");
            childrenItems?.forEach((item) => {
              item.setAttribute("tabindex", "-1");
            });
          }
          loggedInMenu!.classList.toggle("max-h--0");
        } else {
          sendEvent("js-account-overlay", { status: "show" });
        }
      } else if (ctaType == "secondary") {
        if (!isLoggedIn) {
          sendEvent("js-account-overlay", { status: "show" });
        }
      }
    });
  });

  document.addEventListener(HEADER_EVENT_NAME, () => {
    // when the page header's scroll behaviour is triggered, collapse the logged in menus
    const allLoggedInMenus = document.querySelectorAll("[js-logged-in-menu]");
    allLoggedInMenus.forEach((currentMenu) => {
      const menuElement = currentMenu as HTMLElement;
      menuElement.style.removeProperty("max-height");
      menuElement.classList.add("max-h--0");
    });
  });
};
